import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../../formInputsV2/styles/tokens';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 16px;
    background: linear-gradient(135deg, #ffe8e8 0%, #ffcdd2 100%);
    border-radius: 8px;
    border: 1px solid #f8b2b2;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    width: 100%;
    margin-bottom: 20px;

    ${(p) => p.$v2 && css`
      gap: 24px;
      padding: 12px 16px;
      border: 1px solid ${v2Colors.warningBorder};
      border-radius: 14px;
      background: ${v2Colors.warningSoft};
      box-shadow: none;
      font-family: ${v2FontFamily};

      @media (max-width: ${v2Breakpoints.tablet}) {
        flex-direction: column;
        align-items: stretch;
      }
    `}
`;

const Title = styled.span`
    color: #2c3e50;
    font-size: 14px;
    font-weight: 500;
    margin: 0;
    line-height: 1.4;
    white-space: nowrap;

    ${(p) => p.$v2 && css`
      font-family: ${v2FontFamily};
      font-size: 14px;
      font-weight: 600;
      color: ${v2Colors.text};
      white-space: normal;
    `}
`;

const PayButton = styled.button`
    background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
    color: white;
    border: none;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 1px 4px rgba(76, 175, 80, 0.2);
    min-width: 100px;
    white-space: nowrap;

    &:hover {
        background: linear-gradient(135deg, #45a049 0%, #3d8b40 100%);
        transform: translateY(-1px);
        box-shadow: 0 2px 6px rgba(76, 175, 80, 0.3);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 1px 2px rgba(76, 175, 80, 0.3);
    }

    &:disabled {
        background: #cccccc;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }

    ${(p) => p.$v2 && css`
      padding: 9px 18px;
      border-radius: 999px;
      background: ${v2Colors.primary};
      box-shadow: none;
      font-family: ${v2FontFamily};
      font-weight: 700;

      &:hover {
        background: ${v2Colors.primaryHover};
        transform: none;
        box-shadow: 0 4px 10px rgba(0, 166, 81, 0.25);
      }
    `}
`;

const InfoIcon = styled.div`
    width: 24px;
    height: 24px;
    background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 12px;
    flex-shrink: 0;

    ${(p) => p.$v2 && css`
      width: 32px;
      height: 32px;
      border: 1px solid ${v2Colors.warningBorder};
      border-radius: 10px;
      background: rgba(245, 158, 11, 0.16);
      font-size: 15px;
    `}
`;

function CompletedScreenSemestraleButton({
  onNavigate,
  disabled = false,
  buttonText = 'Paga ora',
  showIcon = true,
  v2 = false,
}) {
  const handleClick = () => {
    if (onNavigate && !disabled) {
      onNavigate();
    }
  };

  return (
    <Container $v2={v2}>
      <div className="d-flex align-items-center justify-content-center gap-2">
        {showIcon && <InfoIcon $v2={v2}>💳</InfoIcon>}
        <Title $v2={v2}>
          Pagamento semestrale in attesa - Completa la seconda rata
        </Title>
      </div>
      <PayButton
        $v2={v2}
        onClick={handleClick}
        type="button"
      >
        {buttonText}
      </PayButton>
    </Container>
  );
}

CompletedScreenSemestraleButton.propTypes = {
  onNavigate: PropTypes.func.isRequired,
};

export default CompletedScreenSemestraleButton;
